// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-modal-footer{margin-top:20px;padding-top:20px;border-top:1px solid #d3d3d3}.login-modal-footer .create-account-btn{background-color:var(--primary-color);color:#fff}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
